(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProspectivePatient', ProspectivePatient);

    ProspectivePatient.$inject = ['$resource'];

    function ProspectivePatient ($resource) {
        var resourceUrl =  'api/prospective-patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
